<script setup lang="ts">
import Icon from "../Icon.vue";
import type { IconNames } from "../../services/icons";
import type { HelpIndexNode } from "../../types/help";

defineProps<{
	content: HelpIndexNode[],
	selectedFile: string | null,
}>();

const emit = defineEmits<{
	select: [file: string],
}>();
</script>

<template>
	<ul class="help-menu-tree">
		<li v-for="node of content" :key="node.file">
			<a
				href="#"
				class="help-menu-tree__link"
				:class="{ 'help-menu-tree__link--active': node.file === selectedFile }"
				@click.prevent="emit('select', node.file)"
			>
				<Icon v-if="node.icon" :icon="(node.icon as IconNames)" />
				{{ node.title }}
			</a>
			<HelpMenuTree
				v-if="node.content?.length"
				:content="node.content"
				:selected-file="selectedFile"
				@select="(file) => emit('select', file)"
			/>
		</li>
	</ul>
</template>
